import { useEffect, useState } from "react";

const DURATION = 14000;
const nextGap = () => 150000 + Math.random() * 120000;

export const WarmBreeze = () => {
  const [gust, setGust] = useState(0);

  useEffect(() => {
    let timer;
    const blow = () => {
      setGust((g) => Math.abs(g) + 1);
      window.__breezes = (window.__breezes || 0) + 1;
    };
    const loop = () => { timer = setTimeout(() => { blow(); loop(); }, nextGap()); };
    loop();
    window.__triggerBreeze = blow;
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!gust) return;
    const t = setTimeout(() => setGust((g) => -Math.abs(g)), DURATION);
    return () => clearTimeout(t);
  }, [gust]);

  if (gust <= 0) return null;
  return (
    <div key={gust} className="warm-breeze" data-testid="warm-breeze" aria-hidden="true">
      <span className="wb-band wb-a" />
      <span className="wb-band wb-b" />
      <span className="wb-band wb-c" />
    </div>
  );
};
